import { computed } from "mobx";

import type { NodeModel } from "@/models/nodes/types";

/**
 * Checks if the node or any of its descendants is currently hovered.
 */
export function nodeNestedHover(node: NodeModel | undefined): boolean {
  if (!node) return false;

  return computed(() => {
    const hoveredNodeId = node.doc.nodeHover.current;
    if (!hoveredNodeId) return false;

    const hoveredNode = node.doc.nodes.get(hoveredNodeId);
    if (!hoveredNode) return false;

    if (hoveredNode === node) return true;

    return hoveredNode.ancestors.includes(node);
  }).get();
}
